import { createSlice } from "@reduxjs/toolkit";
import {
  getNovel,
  getUserNovel,
  getUserDetail,
  getRecentNovel,
  getFavoriteNovel,
  getSuggestionsNovels,
  getNovelsPagination,
  getSpecialForYou,
  getComingSoonNovel,
  resetUserNovel,
  updateCurrentNovel,
  getLatestNovelComments,
  getBrowsingNovel,
  createNovels,
  updateNovels,
  deleteNovels,
} from "../3- actions/novels";
export const counterSlice = createSlice({
  name: "novelsData",
  initialState: {
    error: null,
    userNovels: [],
    userDetails: [],
    novelsPagination: [],
    recentNovels: [],
    ComingSoonNovels: [],
    specialNovel: [],
    latestNovelComments: [],
    currentNovel: [],
    suggestionNovels: [],
    favoriteNovels: [],
    novelInfiniteScrolling: [],
  },
  reducers: {
    CLEAR_DATA(state) {
      state.userDetails = [];
      state.userDetails.pending = true;
      state.currentNovel = [];
      state.suggestionNovels = [];
      state.favoriteNovels = [];
      state.novelInfiniteScrolling = [];
      state.novelInfiniteScrolling.pending = true;
      state.favoriteNovels.pending = true;
      state.suggestionNovels.pending = true;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getNovel.fulfilled, (state, action) => {
      state.currentNovel = {
        ...state.currentNovel,
        novels: action.payload.data,
        pending: false,
      };
    });
    builder.addCase(updateCurrentNovel.fulfilled, (state, action) => {
      state.currentNovel = {
        ...state.currentNovel,
        novels:
          state.currentNovel.novels._id === action.payload._id
            ? action.payload
            : state.currentNovel,
        pending: false,
      };
    });

    builder.addCase(getNovel.pending, (state, action) => {
      state.currentNovel = {
        ...state.currentNovel,
        pending: true,
      };
    });
    builder.addCase(getRecentNovel.fulfilled, (state, action) => {
      state.recentNovels = {
        ...state.recentNovels,
        novels: action.payload,
        pending: false,
      };
    });
    builder.addCase(getRecentNovel.pending, (state, action) => {
      state.recentNovels = {
        ...state.recentNovels,
        pending: true,
      };
    });
    builder.addCase(getComingSoonNovel.fulfilled, (state, action) => {
      state.ComingSoonNovels = {
        ...state.ComingSoonNovels,
        novels: action.payload,
        pending: false,
      };
    });
    builder.addCase(getComingSoonNovel.pending, (state, action) => {
      state.ComingSoonNovels = {
        ...state.ComingSoonNovels,
        pending: true,
      };
    });
    builder.addCase(getSpecialForYou.fulfilled, (state, action) => {
      state.specialNovel = {
        ...state.specialNovel,
        novels: action.payload,
        pending: false,
      };
    });
    builder.addCase(getSpecialForYou.pending, (state, action) => {
      state.specialNovel = {
        ...state.specialNovel,
        pending: true,
      };
    });
    builder.addCase(getFavoriteNovel.fulfilled, (state, action) => {
      state.favoriteNovels = {
        ...state.favoriteNovels,
        novels: action.payload,
        pending: false,
      };
    });
    builder.addCase(getLatestNovelComments.fulfilled, (state, action) => {
      state.latestNovelComments = {
        ...state.latestNovelComments,
        novels: action.payload,
        pending: false,
      };
    });
    builder.addCase(getLatestNovelComments.pending, (state, action) => {
      state.latestNovelComments = {
        ...state.latestNovelComments,
        pending: true,
      };
    });
    builder.addCase(getFavoriteNovel.pending, (state, action) => {
      state.favoriteNovels = {
        ...state.favoriteNovels,
        pending: true,
      };
    });
    builder.addCase(getSuggestionsNovels.fulfilled, (state, action) => {
      state.suggestionNovels = {
        ...state.suggestionNovels,
        novels: action.payload,
        pending: false,
      };
    });
    builder.addCase(getSuggestionsNovels.pending, (state, action) => {
      state.suggestionNovels = {
        ...state.suggestionNovels,
        pending: true,
      };
    });
    // HOME paginationNovels
    builder.addCase(getNovelsPagination.fulfilled, (state, action) => {
      state.novelsPagination.novels = [...action.payload.data];
      state.novelsPagination.currentPage = action.payload.currentPage;
      state.novelsPagination.numberOfPages = action.payload.numberOfPages;
      state.novelsPagination.pending = false;
    });
    builder.addCase(getNovelsPagination.pending, (state, action) => {
      state.novelsPagination = {
        ...state.novelsPagination,
        pending: true,
      };
    });

    builder.addCase(getBrowsingNovel.fulfilled, (state, action) => {
      state.novelInfiniteScrolling.novels = [
        ...(state.novelInfiniteScrolling.novels || ""),
        ...action.payload.data,
      ];
      state.novelInfiniteScrolling.currentPage = action.payload.currentPage;
      state.novelInfiniteScrolling.numberOfPages = action.payload.numberOfPages;
      state.novelInfiniteScrolling.pending = false;
    });

    builder.addCase(getBrowsingNovel.pending, (state, action) => {
      state.novelInfiniteScrolling = {
        ...state.novelInfiniteScrolling,
        pending: true,
      };
    });

    // userNovels CRUD
    builder.addCase(getUserNovel.fulfilled, (state, action) => {
      state.userNovels.novels = [...action.payload.data];
      state.userNovels.pending = false;
    });
    builder.addCase(getUserNovel.pending, (state, action) => {
      state.userNovels = {
        ...state.userNovels,
        pending: true,
      };
    });
    builder.addCase(getUserDetail.fulfilled, (state, action) => {
      state.userDetails.novels = [...action.payload.data];
      state.userDetails.pending = false;
    });
    builder.addCase(getUserDetail.pending, (state, action) => {
      state.userDetails = {
        ...state.userDetails,
        pending: true,
      };
    });
    //  CRUD
    builder.addCase(createNovels.fulfilled, (state, action) => {
      state.userNovels = {
        ...state.userNovels,
        novels: [action.payload, ...state.userNovels.novels],
      };
    });
    builder.addCase(updateNovels.fulfilled, (state, action) => {
      state.userNovels = {
        ...state.userNovels,
        novels: state.userNovels.novels.map((novel) =>
          novel._id === action.payload._id ? action.payload : novel
        ),
      };
    });
    builder.addCase(deleteNovels.fulfilled, (state, action) => {
      state.userNovels = {
        ...state.userNovels,
        novels: state.userNovels.novels.filter(
          (novel) => novel._id !== action.payload
        ),
      };
    });
    builder.addCase(createNovels.rejected, (state, action) => {
      state.error = { error: action.payload.error || "Server Error" };
    });
  },
});

export default counterSlice.reducer;
export const { CLEAR_DATA } = counterSlice.actions;
